<template>
  <div id="captcha-mask" v-show="visible">
    <div id="captcha-div"></div>
  </div>
</template>

<script>
import config from "../../conf/config";
export default {
  name: "CaptchaMask",
  props: {
    // 控制遮罩层显隐（父组件传递）
    visible: {
      type: Boolean,
      default: false,
    },
    // 验证码配置项（父组件传递）
    captchaConfig: {
      type: Object,
      default: () => ({
        // 请求验证码接口
        requestCaptchaDataUrl:
          window.config.servers.default + "/api" + "/getGenerateCaptcha",
        // 验证验证码接口
        validCaptchaUrl:
          window.config.servers.default + "/api" + "/validateCaptcha",
      }),
    },
  },
  watch: {
    // 监听显隐状态，初始化/销毁验证码
    visible(newVal) {
      // 防抖：延迟初始化/销毁，避免快速切换触发多次
      clearTimeout(this.visibleTimer);
      this.visibleTimer = setTimeout(() => {
        if (newVal) {
          this.initCaptcha();
        } else {
          this.destroyCaptcha();
        }
      }, 100); // 100ms防抖，可根据实际调整
    },
  },
  data() {
    return {
      tacInstance: null, // 保存验证码实例，用于销毁
      isInitializing: false, // 新增：初始化锁（防止异步初始化重复执行）
      hasTriggeredSuccess: false, // 新增：成功回调单次触发标记
      visibleTimer: null, // 新增：防抖定时器
    };
  },
  methods: {
    // 初始化验证码
    async initCaptcha() {
      // 1. 防重复初始化：初始化中/已有实例，直接返回
      if (this.isInitializing || this.tacInstance) return;

      console.log("初始化验证码", this.captchaConfig);
      // 2. 深拷贝配置，避免污染父组件原始配置（关键！）
      const captchaConfig = JSON.parse(JSON.stringify(this.captchaConfig));
      if (!captchaConfig.bindEl) {
        captchaConfig.bindEl = "#captcha-div";
      }

      // 3. 标记初始化中
      this.isInitializing = true;
      // 重置成功回调标记
      this.hasTriggeredSuccess = false;

      try {
        // 4. 重写回调（基于深拷贝的配置，不污染父组件）
        captchaConfig.validSuccess = (res, c, t) => {
          // 防止单次验证成功触发多次回调
          if (this.hasTriggeredSuccess) return;
          this.hasTriggeredSuccess = true;

          this.tacInstance = t;
          // 执行原成功回调（父组件传递的）
          this.captchaConfig.validSuccess &&
            this.captchaConfig.validSuccess(res, c, t);
          // 仅触发1次父组件事件
          this.$emit("valid-success", res);
        };

        captchaConfig.btnCloseFun = () => {
          // 关闭时重置标记
          this.hasTriggeredSuccess = false;
          // 执行原关闭回调
          this.captchaConfig.btnCloseFun && this.captchaConfig.btnCloseFun();
          this.$emit("close");
        };

        // 5. 样式配置
        const style = {
          logoUrl: null,
        };

        // 6. 初始化验证码（确保仅执行1次）
        if (window.initTAC) {
          const tac = await window.initTAC(
            "https://employer.gnis.org.cn/static/file/npm/tac",
            captchaConfig,
            style
          );
          this.tacInstance = tac;
          tac.init();
        }
      } catch (e) {
        console.error("验证码初始化失败:", e);
        this.hasTriggeredSuccess = false;
      } finally {
        // 7. 释放初始化锁
        this.isInitializing = false;
      }
    },
    // 销毁验证码
    destroyCaptcha() {
      // 1. 重置标记
      this.hasTriggeredSuccess = false;
      this.isInitializing = false;

      // 2. 销毁实例（增加多重清理）
      if (this.tacInstance) {
        try {
          // 优先调用官方销毁方法
          this.tacInstance.destroyWindow();
          // 额外清理实例的事件监听/方法（若有）
          this.tacInstance = null;
        } catch (e) {
          console.warn("验证码销毁失败:", e);
        }
      }

      // 3. 清空DOM容器（防止残留）
      const captchaDiv = document.querySelector("#captcha-div");
      if (captchaDiv) {
        captchaDiv.innerHTML = "";
      }
    },
  },
  // 组件销毁时清理验证码实例
  beforeDestroy() {
    clearTimeout(this.visibleTimer); // 清理防抖定时器
    this.destroyCaptcha(); // 销毁验证码实例
    this.hasTriggeredSuccess = false;
    this.isInitializing = false;
  },
};
</script>

<style>
#captcha-mask {
  display: flex;
  z-index: 99999;
  position: fixed; /* 改为fixed，适配滚动场景 */
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.53);
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/CaptchaMask/index.vue